import React from 'react'
import loadable from '@loadable/component'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

// Components
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'
import {configureRoutes} from '@salesforce/retail-react-app/app/utils/routes-utils'
// import {routes as _routes} from '@salesforce/retail-react-app/app/routes'

const fallback = <Skeleton height="75vh" width="100%" />

const Home = loadable(() => import('./pages/home'), {fallback})
const ProductList = loadable(() => import('./pages/product-list'), {fallback})
const Wishlist = loadable(() => import('./pages/wishlist'), {fallback})
const PageDesignerTest = loadable(() => import('./pages/page-designer-test'), {fallback})

const routes = [
    {
        path: '/',
        component: Home,
        exact: true,
    },
    {
        path: '/home-as-feeling',
        component: PageDesignerTest,
        exact: true,
    },
    {
        path: '/test-double-same-plp',
        component: PageDesignerTest,
        exact: true,
    },
    {
        path: '/wishlist',
        component: Wishlist,
        exact: true,
    },
    {
        path: '/search',
        component: ProductList,
        exact: true,
    },
    {
        path: '/:collectionId',
        component: ProductList,
        exact: true,
    },
    {
        path: '/:collectionId/:categoryId/:subcategoryId',
        component: ProductList,
        exact: true,
    },
    // ..._routes,
]

export default () => {
    const config = getConfig()
    return configureRoutes(routes, config, {
        ignoredRoutes: ['/callback', '*'],
    })
}
